import { render, staticRenderFns } from "./GalleryFile.vue?vue&type=template&id=71408781&scoped=true"
import script from "./GalleryFile.vue?vue&type=script&lang=js"
export * from "./GalleryFile.vue?vue&type=script&lang=js"
import style0 from "./GalleryFile.vue?vue&type=style&index=0&id=71408781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71408781",
  null
  
)

export default component.exports